import { ExtendedWalletType, ProviderType } from '@/utils/wallet/types';

import { WalletType } from './wallet';

// 根据chainType和authType获取对应的钱包类型-连接对应的钱包
export const getUserWalletType = (chainType: WalletType, authType?: string): ProviderType => {
  let walletType: ProviderType = chainType;
  if (authType === WalletType.OKX) {
    if (walletType === WalletType.EVM) {
      walletType = WalletType.OKX;
    }
    if (walletType === WalletType.BITCOIN) {
      walletType = ExtendedWalletType.OKXBTC;
    }
  }
  if (authType === WalletType.WALLETCONNECT) {
    walletType = WalletType.WALLETCONNECT;
  }
  if (authType === WalletType.Coinbase) {
    walletType = WalletType.Coinbase;
  }
  if (authType === ExtendedWalletType.UNISAT) {
    walletType = ExtendedWalletType.UNISAT;
  }
  return walletType;
};
